const environment = 'market';  // 'market', 'enterprice', 'staging', localhost
const map_type = 'google';  // 'google', 'bing'
const jll = ["jllglobalconnect.com", "residentialconnect.com"];
const creationhome = [2106696712, 482949012, 742664596];
const billbergia = [1994725586];
const koham = [279558377];
export default { environment, map_type, jll, creationhome, billbergia, koham } 


// WEBPACK FOOTER //
// ./src/assets/js/global.js